function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_15653_5453)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_15653_5453)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M-0.652344 0.818115H36.589V17.1818H-0.652344V0.818115Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M-0.652344 11.7261H36.589V17.1817H-0.652344V11.7261Z",
  fill: "#D50000"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M-0.652344 6.27368H36.589V11.7261H-0.652344V6.27368Z",
  fill: "#0000BF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.90847 3.79033C9.763 5.75908 9.67571 6.83933 9.33749 7.33791C8.96653 7.87484 8.61012 8.26795 7.16629 8.74416C5.72609 8.26795 5.36968 7.87484 4.99872 7.33791C4.65686 6.83933 4.57321 5.75908 4.42773 3.79033L4.63867 3.72641C5.06782 3.61135 5.38786 3.51867 5.62426 3.47712C5.96249 3.4132 6.25343 3.34288 7.16265 3.3269C8.07186 3.33969 8.36281 3.41639 8.70104 3.48031C8.9338 3.52506 9.26839 3.60815 9.6939 3.72641L9.90847 3.79033Z",
  fill: "#D50000"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.69754 3.72641C9.55933 5.69196 9.44296 6.59324 9.26111 7.0247C8.91197 7.76618 8.35917 8.17207 7.16628 8.55879C5.9734 8.17207 5.4206 7.76618 5.06782 7.0247C4.88598 6.59004 4.77687 5.69196 4.63867 3.72321C5.06055 3.60815 5.38786 3.51867 5.62426 3.47712C5.96249 3.4132 6.25343 3.33969 7.16265 3.3269C8.07186 3.33969 8.36281 3.4132 8.70104 3.47712C9.03767 3.54446 9.37026 3.6266 9.69754 3.72321V3.72641Z",
  fill: "#0000BF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.16736 4.32739L7.22192 4.44565L7.4765 4.47761L7.31284 4.5639L7.46922 4.65658L7.2401 4.68854L7.16736 4.79721L7.09463 4.68535L6.87641 4.65978L7.02189 4.5639L6.86914 4.47761L7.11281 4.44565L7.16736 4.32739Z",
  fill: "#FFDF00"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.17861 6.55828L9.03677 6.4624L8.93858 6.31539L8.74219 6.16517L8.63672 6.01496L8.44033 5.85835L8.34577 5.70814L8.23667 5.63463L8.1712 5.57391L7.98936 5.71134L7.8948 5.86155L7.77478 5.95743L7.64022 5.86475L7.54203 5.71134L7.16743 5.12646L6.79283 5.71134L6.69464 5.86475L6.56008 5.95743L6.44006 5.86155L6.34186 5.71134L6.16366 5.57391L6.09456 5.63144L5.98909 5.70814L5.89453 5.85835L5.69814 6.01496L5.59267 6.16517L5.39628 6.31539L5.29809 6.4624L5.15625 6.55828C5.23621 6.99821 5.47308 7.40445 5.83271 7.71844C6.22286 8.01188 6.67525 8.23455 7.16379 8.37362C7.65606 8.23766 8.1115 8.0147 8.50216 7.71844C8.71309 7.52668 9.10587 7.10161 9.17861 6.55828Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.76428 3.49953L7.82247 3.61779L8.07705 3.64975L7.90975 3.73604L8.06977 3.82872L7.84065 3.86068L7.76791 3.96935L7.69518 3.85749L7.47697 3.83192L7.62244 3.73604L7.46969 3.64975L7.70973 3.61779L7.76791 3.49953H7.76428ZM6.56412 3.49953L6.62231 3.61779L6.87689 3.64655L6.71323 3.73284L6.86961 3.82553L6.64049 3.85749L6.56775 3.96615L6.49502 3.85749L6.2768 3.82872L6.42228 3.73284L6.26953 3.64655L6.5132 3.61459L6.56775 3.49634L6.56412 3.49953Z",
  fill: "#FFDF00"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.8651 7.30598H8.59597L8.34139 7.28999L8.03953 7.16215H7.69767L7.40308 7.28999L7.16669 7.30917L6.93393 7.28999L6.63935 7.16215H6.29384L5.98835 7.28999L5.73741 7.30917L5.461 7.30598L5.33008 7.10782L5.33371 7.10143L5.74104 7.16215L5.99199 7.14617L6.29384 7.01514H6.63571L6.93393 7.14298L7.16669 7.16215L7.40308 7.14298L7.69767 7.01514H8.03953L8.34503 7.14298L8.59597 7.16215L8.98875 7.09823L8.99603 7.11102L8.86146 7.30598H8.8651ZM5.72286 7.6096L5.99199 7.59362L6.29384 7.46578H6.63571L6.93393 7.59362L7.16669 7.6096L7.39945 7.59362L7.69767 7.46578H8.03953L8.34139 7.59362L8.61416 7.6096L8.78873 7.41784H8.78509L8.59597 7.46258L8.34503 7.4466L8.04317 7.31876H7.70131L7.40308 7.4466L7.17033 7.46578L6.93393 7.4466L6.63935 7.31876H6.29384L5.98835 7.4466L5.73741 7.46578L5.55556 7.42423V7.43062L5.71922 7.6096H5.72286Z",
  fill: "#0000BF"
})));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.96875,
  y: 0.5,
  width: 25,
  height: 17,
  rx: 1.5,
  stroke: "#E0E4E8"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_15653_5453"
}, /*#__PURE__*/React.createElement("rect", {
  x: 1.46875,
  y: 1,
  width: 24,
  height: 16,
  rx: 1,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_15653_5453"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24.8276,
  height: 16.3636,
  fill: "white",
  transform: "translate(1.05469 0.818115)"
})));

function SvgSk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk);
export default __webpack_public_path__ + "static/media/sk.188e0151.svg";
export { ForwardRef as ReactComponent };